define('adminImprintTechnologiesCreateEditView',[
  'module',
  'underscore',
  'marionette',
  'backbone',
  'jquery',
  'dialogFormView',
  'template!adminImprintTechnologiesCreateEditTpl',
  'savingBehavior',
  'dynamicTextView'
], function (
  module,
  _,
  Marionette,
  Backbone,
  $,
  DialogFormView,
  createEditLayoutTpl,
  SavingBehavior,
  DynamicTextView
) {
  'use strict';

  var CreateEditLayoutView = DialogFormView.extend({
    template: createEditLayoutTpl,

    ui: {
      input: '.js-info-input',
      individualPrinting: '#individualPrinting'
    },

    events: {
      'click .js-cancel-popup': 'hide',
      'focus @ui.input': 'onFocus',
      'change @ui.input': 'onInputChange',
      'click .js-confirm': 'onConfirm',
      'change @ui.individualPrinting': 'onChangeIndividualPrinting',
      'change .checkbox-input': 'onChangeCheckboxInput'
    },

    regions: {
      nameRegion: '.name-region',
      vrpWarningMessageRegion: '.vrp-warning-message-region'
    },

    className: 'profile-create-edit',

    behaviors: {
      Saving: {
        behaviorClass: SavingBehavior
      }
    },

    modelEvents: {
      sync: 'onSave',
      error: 'onSaveError'
    },

    fieldsToValidate: [
      {name: 'code', type: 'required'}
    ],

    onChangeCheckboxInput: function (e) {
      var inp = $(e.target);
      this.model.set(inp.data('field-name'), inp.is(':checked'));
      this.triggerMethod('enable:cancel:confirm');
    },

    onChangeIndividualPrinting: function () {
      this.model.set('individualPrinting', this.ui.individualPrinting.is(':checked'));
      this.triggerMethod('enable:cancel:confirm');
    },

    initialize: function (options) {
      this.model = options.itModel;
    },

    serializeData: function () {
      var templateData = this.model.toJSON();
      templateData.newItem = this.options.newItem;
      return templateData;
    },

    onShow: function () {
      $.material.init();

      this.nameDtView = new DynamicTextView({
        model: this.model.get('name'),
        noSaving: true,
        hideGlossary: true
      });
      this.nameDtView.dataUpdated = _.bind(function () {
        this.triggerMethod('enable:cancel:confirm');
      }, this);
      this.getRegion('nameRegion').show(this.nameDtView);

      this.vrpWarningMessageDtView = new DynamicTextView({
        model: this.model.get('vrpWarningMessage'),
        noSaving: true,
        hideGlossary: true,
        textAreaMode: true
      });
      this.vrpWarningMessageDtView.dataUpdated = _.bind(function () {
        this.triggerMethod('enable:cancel:confirm');
      }, this);
      this.getRegion('vrpWarningMessageRegion').show(this.vrpWarningMessageDtView);
    },

    onConfirm: function () {
      if (this.validate(this.fieldsToValidate)) {
        this.model.save();
      }
    },

    onSave: function () {
      this.triggerMethod('saved');
      this.hide();
    },

    onSaveError: function (model, response) {
      if (response.status === 409) {
        this.onDuplicateCode();
        this.triggerMethod('hide:label');
      }
    }
  });

  module.exports = CreateEditLayoutView;
});
